var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagChina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.25 75C58.9607 75 75.75 58.2107 75.75 37.5C75.75 16.7893 58.9607 0 38.25 0C17.5393 0 0.75 16.7893 0.75 37.5C0.75 58.2107 17.5393 75 38.25 75Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2725 22.8223L24.5098 32.7832H34.9834L26.5166 38.9502L29.7539 48.9111L21.2725 42.7588L12.791 48.9111L16.043 38.9502L7.56152 32.7832H18.0352L21.2725 22.8223Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.208 58.0811L42.7324 55.0342L39.0703 56.4551L41.1943 53.1592L38.7188 50.0977L42.5127 51.1084L44.6514 47.8125L44.8565 51.7383L48.6651 52.749L44.9883 54.1553L45.208 58.0811Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1299 49.1455L51.3018 45.3955L48.0938 43.125L52.0195 43.0664L53.1768 39.3164L54.4512 43.0371L58.3769 42.9932L55.2275 45.3369L56.4873 49.0576L53.2793 46.7871L50.1299 49.1455Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7656 27.5244L55.0371 31.0547L57.8496 33.7939L53.9678 33.2373L52.2393 36.7529L51.5654 32.8857L47.6689 32.3291L51.1553 30.498L50.4814 26.6162L53.2939 29.3555L56.7656 27.5244Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3106 16.8311L45.0176 20.7422L48.665 22.2217L44.8418 23.1592L44.5635 27.085L42.4981 23.7451L38.6748 24.6826L41.209 21.6797L39.1289 18.3545L42.7764 19.834L45.3106 16.8311Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagChina);
export default __webpack_public_path__ + "static/media/flagChina.fcd54074ea55352988cd54139b9bc6a3.svg";
export { ForwardRef as ReactComponent };